const ActionTypes = {
  GET_QUOTE_REQUEST: "GET_QUOTE_REQUEST",
  GET_QUOTE_SUCCESS: "GET_QUOTE_SUCCESS",
  GET_QUOTE_FAILURE: "GET_QUOTE_FAILURE",
  GET_QUOTE_CLEAN_UP: "GET_QUOTE_CLEAN_UP"
};

export default ActionTypes;
